
// FILE TYPES
export const GET_FILE_TYPES = "/file-types";
export const ADD_NEW_FILE_TYPE = "/file-types";
export const UPDATE_FILE_TYPE = "/file-types";
export const DELETE_FILE_TYPE = "/file-types";


